// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4567":"e3d4b74a","6845":"e3d4b74a"}[chunkId] + ".chunk.css";
};